import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";


export default function isCitizenshipNumber(str, responseText) {
    const regVal = regexList.citizenshipNo.pattern;
    return regexTest(str, regVal, responseText) || regexList.citizenshipNo.response;
}